<template>
  <v-container class="max-width py-0 text-center">
    <v-row class="pa-0 align-center">
      <v-col cols="12" md="8">
        <v-pagination
          v-if="resourceSettings.pagination && resource && resource.last_page"
          v-model="resource.current_page"
          class="my-0"
          :total-visible="10"
          color="primary"
          @input="pageByNumber"
          :length="resource.last_page"
        ></v-pagination>
        <v-btn x-small color="success" :class="`${arabic?'arFont':'enFont'}`" @click="loadResource()">{{i18n.reload}}</v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          :items="numbers"
          outlined
          dense
          v-model="resource.current_page"
          @change="pageByNumber"
          label="Pages"
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props:['resourceSettings', 'resource'],
  data(){
    return {
    }
  },
  methods:{
    loadResource() {
      this.$emit('loadResource')
    },
    pageByNumber(n) {
      this.$emit('pageByNumber', n)
    }
  },
  computed:{
    numbers(){
      let all = []
      for (let i = 0; i <= this.resource.last_page; i++) {
        all.push(i)
      }
      return all
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  }
}
</script>

<style>

</style>